var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "body" },
    [
      _c("role-tab", { attrs: { tabs: _vm.bindCorpUsers } }),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "left-tab-warp" }, [_c("left-tab")], 1),
        _c("div", { staticClass: "right-wrap" }, [
          _c("div", { staticClass: "right-content" }, [
            _vm._m(0),
            _c("div", { staticClass: "right flex-between" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "primary", plain: "", size: "small" },
                      on: { click: _vm.gotoSignList }
                    },
                    [_vm._v("去出证")]
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "250px", "margin-right": "8px" },
                    attrs: {
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                      "default-time": ["00:00:00", "23:59:59"],
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      size: "small"
                    },
                    model: {
                      value: _vm.datePikerArr,
                      callback: function($$v) {
                        _vm.datePikerArr = $$v
                      },
                      expression: "datePikerArr"
                    }
                  }),
                  _c("el-input", {
                    staticStyle: { width: "160px", "margin-right": "8px" },
                    attrs: {
                      size: "small",
                      type: "number",
                      clearable: true,
                      placeholder: "请输入数字备案号"
                    },
                    model: {
                      value: _vm.preservationId,
                      callback: function($$v) {
                        _vm.preservationId = $$v
                      },
                      expression: "preservationId"
                    }
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "140px", "margin-right": "8px" },
                      attrs: {
                        size: "small",
                        clearable: "",
                        placeholder: "订单状态"
                      },
                      model: {
                        value: _vm.status,
                        callback: function($$v) {
                          _vm.status = $$v
                        },
                        expression: "status"
                      }
                    },
                    _vm._l(_vm.options, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.queryList } },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.rest } },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "table-warp" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "data-list",
                    style: { "min-height": "64vh" },
                    attrs: {
                      data: _vm.listData,
                      "tooltip-effect": "dark",
                      "header-cell-style": {
                        background: "#f9f9f9",
                        color: "#333333",
                        fontWeight: "500"
                      }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "订单号",
                        prop: "orderNumber",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "备案号", prop: "preservationId" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("leftPadZero")(
                                      scope.row.preservationId,
                                      10
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { label: "持有人", prop: "preservationName" }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "受理机关",
                        prop: "orgName",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "创建日期", prop: "applyTime" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("formatDate")(scope.row.applyTime)
                                  ) +
                                  "\n                "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "订单状态",
                        prop: "statusStr",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.status === 1
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "color-success pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.gotoTestifyOnLoginStatus(
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("立即支付")]
                                  )
                                : _vm._e(),
                              scope.row.status === 5
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "color-success pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.showFileReason(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("查看原因")]
                                  )
                                : _vm._e(),
                              scope.row.status === 4
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "color-success pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.downTestifyPrePkg(
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("下载证书")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "com-custom-nodata",
                        attrs: { slot: "empty" },
                        slot: "empty"
                      },
                      [
                        _c("img", {
                          staticClass: "simg",
                          attrs: {
                            src: "/images/judicialService/zxgz-no-data.png"
                          }
                        })
                      ]
                    )
                  ],
                  1
                ),
                _vm.listData && _vm.listData.length > 0
                  ? _c(
                      "el-row",
                      { staticClass: "pageation row" },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("div", { staticStyle: { height: "20px" } })
                        ]),
                        _c(
                          "el-col",
                          { staticClass: "page-flex-end", attrs: { span: 18 } },
                          [
                            _vm.paged.total > 0
                              ? _c("el-pagination", {
                                  attrs: {
                                    "pager-count": 5,
                                    total: _vm.paged.total,
                                    "current-page": _vm.paged.pageNum,
                                    "page-size": _vm.paged.pageSize,
                                    "page-sizes": [10, 20, 50, 100],
                                    layout: "sizes, prev, pager, next, total"
                                  },
                                  on: {
                                    "size-change": _vm.handleSizeChange,
                                    "current-change": _vm.handleCurrentChange,
                                    "update:currentPage": function($event) {
                                      return _vm.$set(
                                        _vm.paged,
                                        "pageNum",
                                        $event
                                      )
                                    },
                                    "update:current-page": function($event) {
                                      return _vm.$set(
                                        _vm.paged,
                                        "pageNum",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            _c("el-go", {
                              attrs: {
                                "page-size": _vm.paged.pageSize,
                                total: _vm.paged.total
                              },
                              on: { "current-change": _vm.handleCurrentChange }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-toolbar" }, [
      _c("h2", { staticClass: "title" }, [_vm._v("公证证书")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ae02f94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ae02f94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/judicialService/safeguard.vue
// module id = KBNK
// module chunks = 68